import instance from "../../utils/axios";

const toFormData = (payload = {}) => {
  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([key, val]) => {
    if (val === undefined || val === null) return;
    if (Array.isArray(val)) {
      formData.append(key, JSON.stringify(val));
    } else {
      formData.append(key, String(val));
    }
  });
  return formData;
};

export const readActiveAgreements = async (payload = {}) => {
  const response = await instance.post("/agreements/readactive", toFormData(payload));
  return response.data;
};

export const saveAgreementConsent = async (payload = {}) => {
  const response = await instance.post("/agreements/consent/save", toFormData(payload));
  return response.data;
};

export const readAgreements = async (payload = {}) => {
  const response = await instance.post("/agreements/read", toFormData(payload));
  return response.data;
};

export const saveAgreement = async (payload = {}) => {
  const response = await instance.post("/agreements/save", toFormData(payload));
  return response.data;
};

export const updateAgreement = async (payload = {}) => {
  const response = await instance.post("/agreements/update", toFormData(payload));
  return response.data;
};

export const deleteAgreement = async (payload = {}) => {
  const response = await instance.post("/agreements/delete", toFormData(payload));
  return response.data;
};

export const readConsentAnalytics = async (payload = {}) => {
  const response = await instance.post(
    "/agreements/consent/analytics/read",
    toFormData(payload)
  );
  return response.data;
};

export const readConsentUsers = async (payload = {}) => {
  const response = await instance.post("/agreements/consent/users/read", toFormData(payload));
  return response.data;
};

export const readConsentEntityAnalytics = async (payload = {}) => {
  const response = await instance.post(
    "/agreements/consent/entity/analytics/read",
    toFormData(payload)
  );
  return response.data;
};

export const readConsentEntityDetails = async (payload = {}) => {
  const response = await instance.post(
    "/agreements/consent/entity/details/read",
    toFormData(payload)
  );
  return response.data;
};
